var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.23514 13.9384C1.76458 14.4088 1.50014 15.0469 1.5 15.7123V17H2.78774C3.45312 16.9999 4.09119 16.7354 4.5616 16.2649L12.931 7.89547L10.6045 5.56901L2.23514 13.9384Z",
    fill: "#4E545D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0177 2.48231C15.8649 2.32941 15.6836 2.20811 15.4839 2.12536C15.2843 2.0426 15.0703 2 14.8541 2C14.638 2 14.424 2.0426 14.2244 2.12536C14.0247 2.20811 13.8433 2.32941 13.6906 2.48231L11.4915 4.68208L13.8179 7.00854L16.0177 4.80941C16.1706 4.65667 16.2919 4.47529 16.3746 4.27564C16.4574 4.07599 16.5 3.86198 16.5 3.64586C16.5 3.42974 16.4574 3.21573 16.3746 3.01608C16.2919 2.81644 16.1706 2.63505 16.0177 2.48231Z",
    fill: "#4E545D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/EditPencil.98755a90b5c595920cdee9363377b144.svg";
export { ForwardRef as ReactComponent };